// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'dev',
  production: false,
  region: 'NA',
  appUrl: 'https://performance.dev.zonarsystems.net',

  apiBase: {
    url: 'https://performance-api.dev.zonarsystems.net',
    tripApiUrl: 'https://trip-api.dev.zonarsystems.net',
    zonarUrl: 'https://api-dev.zonarsystems.net'
  },

  coreEntityApiBase: {
    url: 'https://api-dev.zonarsystems.net/core/v1'
  },

  geocoderApi: {
    url: 'https://zonar-nonprod-dev.apigee.net'
  },

  locationApi: {
    assetPropertiesUrl: 'https://location-writer-db.dev.zonarsystems.net'
  },

  //  TODO: Setup your application's authentication variables: see
  //  https://gitlab.com/ZonarSystems/tools/pattern-library/-/tree/master/projects/zonar-ui-auth
  // for instructions on how to do that.
  authEnv: 'development',

  auth: {
    clientID: 'Jp5NmipXtnSBwbYVkGGzHmyUVmr8Stkz',
    domain: 'zonar-dev.auth0.com',
    audience: 'http://apidev.zonarsystems.net/',
    // These come from the Core APIs as your application is built.
    applicationId: '0264021d-e7cb-471b-b39a-76cc3296e90a',
    defaultZonarRole: 'c73bd197-ab9d-42cb-a12e-de66345b7452',
    useRefreshTokens: true
  },

  pendo: {
    url: 'https://cdn.pendo.io/agent/static/'
  },

  devCycle: {
    clientId: 'dvc_client_4396acae_4988_4275_aaa5_65ac9afb1b3f_2e0b910'
  },

  googleTagManager: {
    id: 'GTM-PM9R42P',
    auth: '',
    environment: ''
  },

  //TODO: Setup your application's datadog app (see empty box readme)
  datadog: {
    applicationId: '20c6b17b-0769-43ff-abc6-954875a39d97',
    clientToken: 'pub59c421a6b04b28afd8a978bcb891452b',
    site: 'us5.datadoghq.com',
    tagEnvironment: 'development'
  },

  i18n: {
    supportedLanguages: [
      'en-US',
      'de-DE',
      'en-GB',
      'it-IT',
      'fr-FR',
      'es-ES',
      'en-CA'
    ],
    defaultLanguage: 'en-US'
  },
  features: {
    'usage:summary': true,
    'usage:trend': true,
    'idle:summary': true,
    'idle:trend': true,
    'idle:top': true
  },
  here: {
    apiKeyV3: 'iRhaHB0jRt7Np-iRhaHB0jRt7Np-2bHVzybLZ0fIVGvAixLJ0Y5VLbRX4'
  },
  adminSettings: {
    url: 'https://settings.zonarsystems.net/threshold-settings',
    applicationId: '93818bc1-8c96-4e62-a460-232b7c679239'
  },
  userPreferenceApiBase: {
    url: 'https://api-dev.zonarsystems.net/alert/v1'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
